import { useState } from "react";
import Input from "../../../components/Common/Input";
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom'
import { emailValidate } from "../../../components/Common/form-validations";



function ForgotPassword() {
    const [showSuccessMsg,setshowSuccessMsg] = useState(false);
    const { register, handleSubmit, formState: { errors, isValid, submitCount }, getFieldState, reset, } = useForm();


    const validateLogin = (data) => {
        if (isValid) {
            reset();
          //  console.log(data);
            setshowSuccessMsg(!showSuccessMsg)
        } 
    }

 
    return (
        <section className="py-10"> 
            <div className="flex flex-col items-center justify-start px-3 mx-auto lg:py-8">
                <div className="w-full bg-white rounded-lg md:shadow-sm mb-16 sm:max-w-md xl:p-0">
                    <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                        <div className="text-center">
                            <h1 className="text-xl font-bold leading-tight py-2 tracking-tight text-gray-900 md:text-2xl">
                               Reset Password
                            </h1>
                          
                            <p className="tracking-tight font-normal text-base text-gray-400">We'll email you instructions to reset your password</p>
                        </div>
                        <form noValidate onSubmit={handleSubmit(validateLogin)} className="space-y-4 md:space-y-4">
                            {/* Input Fields */}
                            <div className="w-full">
                                <Input type="email" label="" autoComplete="off" classname={`${errors.email ? "input-error-form-control" : ""} ${submitCount >= 1 ? (getFieldState("email").isDirty && !getFieldState("email").invalid) ? "input-success-form-control" : null : ""}`} placeholder="name@mail.com" {...register("email", { ...emailValidate })} />
                                {errors.email && <div className='input-errors flex items-center justify-start'> <svg xmlns="http://www.w3.org/2000/svg" fill="#cc0505" className="w-4 mr-1" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" /></svg>
                                    {errors.email.message}
                                </div>}
                                {showSuccessMsg && <p className="text-green-600 text-sm text-left mt-2 px-2">if your email registered with us you'll received a mail to reset password!</p>}
                            </div>
            
                            <button type="submit" disabled={!(Object.keys(errors).length === 0)} className="w-full inline-flex justify-center items-center text-white bg-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-4 mx-1"> <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" clipRule="evenodd" /> </svg>
                                Reset Password
                            </button>

                            <p className="text-sm font-normal text-gray-500 text-center">
                               <Link to="/login" className="font-medium text-indigo-600 hover:underline inline-flex justify-center items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 me-1 mt-[1.5px] hover:underline"> <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18" /> </svg>
                                Back to Login</Link>
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default ForgotPassword;